import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findVideoAdminList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`schoolVideo/findVideoAdminList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  selectVideoIdList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`schoolVideo/selectVideoIdList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  lookSchoolVideo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`schoolVideo/lookSchoolVideo`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  classifyIdList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`schoolVideo/classifyIdList`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  recommendedCoursesInterfaceList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`schoolVideo/recommendedCoursesInterfaceList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
  insertVideoAdmin({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`schoolVideo/insertVideoAdmin`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  delVideo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`schoolVideo/delVideo`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
